import React, { useState } from "react";
import MainToolbar from "../MainToolbar";
import EditCollectionView from "../EditCollectionView";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableColumn,
  TableBody,
  Paper,
  makeStyles,
  FormControlLabel,
  IconButton,
  Checkbox,
  Button,
  Tooltip,
} from "@material-ui/core";
import t from "../common/localization";
import {
  formatHours,
  formatDate,
  formatVolume,
  formatDurationTime,
} from "../common/formatter";
import ReportFilter from "./ReportFilter";
import ReportLayoutPage from "./ReportLayoutPage";
import { useAttributePreference, usePreference } from "../common/preferences";
import { useEffectAsync } from "../reactHelper";
import { showLoaderStateActions } from "../store";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { ReceiptRounded } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "#F2F5FC",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 690,
  },
}));

const Filter = ({ setItems }) => {
  const dispatch = useDispatch();
  const userID = usePreference("id");

  const handleSubmit = async (deviceId, groupId, from, to, mail, headers) => {
    const query = new URLSearchParams({
      userId: userID,
      from,
      to,
      actionBy: false,
      mail: false,
    });
    dispatch(showLoaderStateActions.addState(true));
    try {
      const response = await fetch(
        `/api/paymentGatewayPointsOrder/getTransactions?userId=${userID}&${query.toString()}`,
        { headers },
      );

      if (!response.ok) {
        dispatch(showLoaderStateActions.addState(false));
        return;
      }

      const data = await response.json();

      dispatch(showLoaderStateActions.addState(false));

      setItems(data);
    } catch (error) {
      dispatch(showLoaderStateActions.addState(false));
      console.error("Error fetching point transactions:", error);
    }

    // if (response.ok && response.headers.get("content-type")) {
    //   const contentType = response.headers.get("content-type");
    //     if (contentType === "application/pdf") {
    //       const name = "report.pdf";
    //       const blobUrl = URL.createObjectURL(await response.blob());
    //       // Create a link element
    //       const link = document.createElement("a");
    //       // Set link's href to point to the Blob URL
    //       link.href = blobUrl;
    //       link.download = name;
    //       // Append link to the body
    //       document.body.appendChild(link);
    //       // Dispatch click event on the link
    //       // This is necessary as link.click() does not work on the latest firefox
    //       link.dispatchEvent(
    //         new MouseEvent("click", {
    //           bubbles: true,
    //           cancelable: true,
    //           view: window,
    //         })
    //       );
    //       // Remove link from body
    //       document.body.removeChild(link);
    //       dispatch(showLoaderStateActions.addState(false));
    //     } else if (contentType === "application/json") {
    //       const resItem = await response.json();
    //       dispatch(showLoaderStateActions.addState(false));
    //       setItems(resItem);
    //     } else {
    //       dispatch(showLoaderStateActions.addState(false));
    //       window.location.assign(
    //         window.URL.createObjectURL(await response.blob())
    //       );
    //     }
    // } else {
    //   dispatch(showLoaderStateActions.addState(false));
    // }
  };
  return (
    <ReportFilter
      handleSubmit={handleSubmit}
      reportHeader="Point Transaction Report"
      showOnly={true}
    />
  );
};
const OnlinePointTransactionsReportPage = () => {
  const classes = useStyles();

  const [items, setItems] = useState([]);

  let mainData = [];
  const setRecursiveData = (newItems) => {
    setTimeout(() => {
      let hasMore = mainData.length + 1 < newItems.length;
      const list = newItems.slice(0, mainData.length + 1);
      mainData = list;
      setItems(list);
      if (hasMore) setRecursiveData(newItems);
    }, 0);
  };

  const setData = (newItems) => {
    mainData = [];
    setRecursiveData(newItems);
  };

  const columns = [
    {
      field: "date",
      headerName: "Date",
      width: 180,
    },

    {
      field: "status",
      headerName: "Transaction Status",
      width: 180,
    },

    {
      field: "devicePoints",
      headerName: "Device Points",
      width: 160,
    },

    {
      field: "rate",
      headerName: "Rate",
      width: 130,
    },

    {
      field: "amount",
      headerName: "Total Amount",
      width: 160,
    },

    {
      field: "reference",
      headerName: "Reference Number",
      width: 220,
    },

    {
      field: "transaction",
      headerName: "Transaction Number",
      width: 220,
    },

    {
      field: "error",
      headerName: "Error",
      width: 200,
    },

    {
      field: "invoiceNumber",
      headerName: "Invoice Number",
      width: 180,
    },

    {
      field: "download",
      headerName: "Download Invoice",
      width: 180,
      renderCell: (params) => {
        const hasInvoice = !!params.row.invoiceUrl;

        return (
          <Tooltip
            title={hasInvoice ? "Download Invoice" : "No Invoice Available"}
          >
            <span>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={!hasInvoice}
                onClick={() => {
                  window.open(params.row.invoiceUrl, "_blank");
                }}
              >
                Download
              </Button>
            </span>
          </Tooltip>
        );
      },
    },
  ];

  const gridRows = items.map((item) => ({
    id: item.id,
    date: new Date(item.createdAt).toLocaleString(),
    status: item.txnStatus,
    devicePoints: item.devicePoints,
    rate: item.devicePointsRate,
    amount: item.totalOrderAmount,
    reference: item.referenceId,
    transaction: item.transactionNumber,
    error: item.errorMessage || "-",
    invoiceNumber: item.zohoBooksInvoiceNumber || "-",
    invoiceUrl: item.zohoBooksInvoiceUrl,
  }));

  return (
    <ReportLayoutPage filter={<Filter setItems={setData} />}>
      {/* <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          className={classes.tableAction}
        >
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.columnAction} />
              <TableCell className={classes.tCell}>
                {t("reportUsername")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportUserUniqueId")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportDeviceName")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportDeviceUniqueId")}
              </TableCell>
              <TableCell className={classes.tCell}>{t("reportTime")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("reportPoints")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportUserRenewal")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportUserRevival")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportDeviceRenewal")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportDeviceRevival")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportRemarks")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell className={classes.columnAction}></TableCell>
                <TableCell>
                  <b>{item.username}</b>
                </TableCell>
                <TableCell>{item.userUniqueId}</TableCell>
                <TableCell>{item.deviceName}</TableCell>
                <TableCell>{item.deviceUniqueId}</TableCell>
                <TableCell>{formatDurationTime(item.time, "LLL")}</TableCell>
                <TableCell>{item.points}</TableCell>
                <TableCell>{item.attributes.remarks}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <DataGrid
        rows={gridRows}
        columns={columns}
        disableSelectionOnClick
        autoHeight={false}
        pageSize={50}
        rowsPerPageOptions={[50, 100, 500]}
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        pagination
      />
    </ReportLayoutPage>
  );
};

export default OnlinePointTransactionsReportPage;
